export class Details {
    registrationDetails: registrationDetail;
}

export class registrationDetail {
    RegistrationStartTime: string;
    RegistrationEndTime: string;
}
